import { render, staticRenderFns } from "./BankDeposit.vue?vue&type=template&id=1166c636&scoped=true&"
import script from "./BankDeposit.vue?vue&type=script&lang=js&"
export * from "./BankDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1166c636",
  null
  
)

export default component.exports